// extracted by mini-css-extract-plugin
module.exports = {"withdrawalTypeContainer":"styles_withdrawalTypeContainer__axiS_","partialBalanceMessaging":"styles_partialBalanceMessaging__1zUp6","sellDate":"styles_sellDate__2TifI"};